import { render, staticRenderFns } from "./ContentSection.vue?vue&type=template&id=e27cf74c&scoped=true&"
import script from "./ContentSection.vue?vue&type=script&lang=js&"
export * from "./ContentSection.vue?vue&type=script&lang=js&"
import style0 from "./ContentSection.vue?vue&type=style&index=0&id=e27cf74c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e27cf74c",
  null
  
)

export default component.exports